var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import styled from 'styled-components';
import AdminPageEmptyState from './admin_page_empty_state';
import { MemberRoles as Roles, memberStatus as MemberStatus, } from '../types/members';
import Table from '@doordash/component-table';
import { Text, InlineChildren, BorderRadius, Icon, Colors, } from '@doordash/design-language';
import Tag from '@doordash/component-tag';
import Popover from '@doordash/component-popover';
import ListCell from '@doordash/component-list-cell';
import { IconButton } from '@doordash/component-button';
import { tableStyle } from './AdminPage/AdminPageStyles';
import { MembersPageTestId } from './testId';
var PopoverContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  min-width: 200px;\n  border-radius: ", "px;\n"], ["\n  min-width: 200px;\n  border-radius: ", "px;\n"])), BorderRadius.Medium);
export var ActionMenu = function (_a) {
    var member = _a.member, onRemoveMemberClick = _a.onRemoveMemberClick, currentTeamMember = _a.currentTeamMember, onToggleAdminAccess = _a.onToggleAdminAccess;
    var _b = __read(React.useState(false), 2), isPopoverVisible = _b[0], setIsPopoverVisible = _b[1];
    var isMemberCurrentUser = member.id === currentTeamMember.id;
    var isMemberAdmin = member.roles && member.roles.includes(Roles.ADMIN);
    var menuOptions = [
        {
            key: 'remove-member',
            title: 'Remove employee',
            testId: MembersPageTestId.RemoveEmployee,
            isDisabled: isMemberCurrentUser,
            onActionClick: function (e) {
                e.stopPropagation();
                setIsPopoverVisible(false);
                onRemoveMemberClick(member);
            },
        },
    ];
    if (!isMemberCurrentUser && member.status === MemberStatus.ACTIVE) {
        var title = isMemberAdmin ? 'Remove admin access' : 'Grant admin access';
        var testId = isMemberAdmin
            ? MembersPageTestId.RevokeAdminAccess
            : MembersPageTestId.GrantAdminAccess;
        menuOptions.unshift({
            key: 'toggle-admin-access',
            title: title,
            testId: testId,
            isDisabled: false,
            onActionClick: function (e) {
                e.stopPropagation();
                setIsPopoverVisible(false);
                onToggleAdminAccess(member);
            },
        });
    }
    var dismissPopover = function () { return setIsPopoverVisible(false); };
    React.useEffect(function () {
        document.addEventListener('click', dismissPopover);
        return function () {
            document.removeEventListener('click', dismissPopover);
        };
    });
    return (React.createElement(Popover, { position: Popover.Positions.BottomRight, interactionType: Popover.InteractionTypes.Controlled, showContainerPointer: false, isVisible: isPopoverVisible, content: React.createElement(PopoverContainer, null, menuOptions.map(function (option) { return (React.createElement(ListCell, { isSeparatorVisible: true, key: option.key, title: option.title, titleOverrides: {
                size: Text.Sizes.S16,
                color: option.isDisabled
                    ? Colors.ButtonFabForegroundDisabled
                    : '',
            }, onClick: option.isDisabled ? null : option.onActionClick, "data-testid": option.testId })); })) }, function (_a) {
        var describedBy = _a.describedBy;
        return (React.createElement(IconButton, { accessibilityLabel: "Actions", accessibilityDescribedBy: describedBy, iconType: IconButton.IconTypes.MoreHorizontal, onClick: function (e) {
                e.stopPropagation();
                e.preventDefault();
                setIsPopoverVisible(!isPopoverVisible);
            }, "data-testid": MembersPageTestId.MembersMenuButton }));
    }));
};
export var AdminMembersList = React.memo(function (_a) {
    var members = _a.members, page = _a.page, onPageChange = _a.onPageChange, isLoading = _a.isLoading, onRemoveMemberClick = _a.onRemoveMemberClick, totalPages = _a.totalPages, currentTeamMember = _a.currentTeamMember, onToggleAdminAccess = _a.onToggleAdminAccess, isSearchMode = _a.isSearchMode;
    var rows = React.useMemo(function () {
        return members.map(function (member) { return ({
            id: member.id,
            email: member.email,
            status: member.status === 'ACTIVE' ? 'Active' : 'Pending',
            roles: member.roles,
            member: member,
        }); });
    }, [members]);
    var columns = React.useMemo(function () { return [
        {
            name: 'EMAIL',
            accessor: 'email',
            Cell: function (props) {
                var _a = props.row.original, roles = _a.roles, email = _a.email;
                var isAdmin = roles && roles.includes(Roles.ADMIN);
                return (React.createElement(InlineChildren, null,
                    React.createElement(Text, { color: Text.Colors.TextSecondary }, email),
                    isAdmin && React.createElement(Tag, { text: 'Admin' })));
            },
        },
        {
            name: 'STATUS',
            accessor: 'status',
        },
        {
            name: 'menu',
            accessor: 'id',
            Cell: function (props) {
                var member = props.row.original.member;
                return (React.createElement(ActionMenu, { member: member, currentTeamMember: currentTeamMember, onRemoveMemberClick: onRemoveMemberClick, onToggleAdminAccess: onToggleAdminAccess }));
            },
        },
    ]; }, [onToggleAdminAccess, onRemoveMemberClick, currentTeamMember]);
    if (!isLoading && totalPages === 0) {
        return (React.createElement(AdminPageEmptyState, { icon: React.createElement(Icon, { type: Icon.Types.PersonFindFill, size: Icon.Sizes.Large }), title: isSearchMode
                ? 'No members found matching your search'
                : 'No Members', subtitle: isSearchMode ? '' : 'Start by adding members to the account' }));
    }
    return (React.createElement(Table, { showDataLoading: isLoading, currentPage: page, manualPagination: true, data: rows, columns: columns, hiddenHeaders: ['id'], isSortable: false, rowsPerPage: members.length, numPages: totalPages, onPageChange: onPageChange, bodyTextProps: {
            size: Text.Sizes.S16,
            color: Text.Colors.TextSecondary,
            weight: Text.Weights.Medium,
        }, headerTextProps: {
            size: Text.Sizes.S12,
            color: Text.Colors.TextSecondary,
            weight: Text.Weights.Medium,
        }, tableStyles: tableStyle }));
});
export default AdminMembersList;
var templateObject_1;
